import { render, staticRenderFns } from "./spent_only_pane.vue?vue&type=template&id=0706bdc9"
import script from "./spent_only_pane.vue?vue&type=script&lang=js"
export * from "./spent_only_pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports